import { PickersDay, PickersDayProps } from '@mui/x-date-pickers';
import { FC, useEffect, useMemo, useRef } from 'react';

interface CustomPickerDay extends PickersDayProps<moment.Moment> {
  range: DateRangeValue;
}

const CustomPickerDay: FC<CustomPickerDay> = ({
  range,
  day,
  selected,
  ...rest
}) => {
  const pickerRef = useRef<HTMLButtonElement>(null);

  const pickerClassName = useMemo(() => {
    if (range.start && range.end && day >= range.start && day < range.end) {
      return 'Mui-highlighted';
    }
    return undefined;
  }, [range]);

  const pickerSelected = useMemo(
    () => (range.end ? !day.diff(range.end) : selected),
    [range, selected]
  );

  useEffect(() => {
    if (range.end) {
      pickerRef.current?.blur();
    }
  }, [range]);

  return (
    <PickersDay
      {...rest}
      ref={pickerRef}
      day={day}
      className={pickerClassName}
      selected={pickerSelected}
    />
  );
};

export default CustomPickerDay;
